import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CleanHandsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"clean_hands"}/>
}
